import React, { useMemo, useState } from 'react';
import '../../../assets/css/StudentShortDetails.css';
import { formatDateDDMMYYYY, formatDateDDMMYYYYHHMMSS_UTC } from '../../../Utils/data&dateTime';

const ScheduledFeeShortDetails = ({ selectedFeeDetails }) => {
  const [visibleCount, setVisibleCount] = useState(20);
  const scheduleData = selectedFeeDetails?.payment_schedule || [];

  const { totalAmount } = useMemo(() => {
    const totals = scheduleData.reduce(
      (acc, item) => {
        acc.totalAmount += parseFloat(item.amount) || 0;
        return acc;
      },
      { totalAmount: 0 }
    );
    return totals;
  }, [scheduleData]);

  return (
    <div className="paymentreporttablecontainer ledgerWrapper"
      style={{ border: "1px solid #E9E9E9", borderRadius: "8px", overflow: "hidden", display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
      <div style={{ flex: 1, minHeight: 0, overflowY: "auto", scrollbarWidth: "thin", scrollbarColor: "#d1d5db transparent" }}>
        <table className="table table-sm table-bordered table-hover student-table fee ledgerTable" style={{ marginBottom: 0 }}>
          <thead className="ledgerHeader" style={{ position: "sticky", top: 0, zIndex: 2 }}>
            <tr>
              <th style={{ padding: "8px 10px", textAlign: 'left' }}>Due Date</th>
              <th style={{ padding: "8px 10px" }}>Fee Head</th>
              <th style={{ padding: "8px 10px", textAlign: 'right' }}>Scheduled Amount</th>
            </tr>
          </thead>
          <tbody className='ledgerBody'>
            {scheduleData.length > 0 ? (
              scheduleData.slice(0, visibleCount).map((txn, idx) => (
                <tr key={idx}>
                  <td style={{ padding: "7px 10px", textAlign: 'left' }}>{txn.due_date}</td>
                  <td style={{ padding: "7px 10px" }}>{txn.fee_head || "N/A"}</td>
                  <td style={{ padding: "7px 10px", textAlign: 'right' }}>
                    ₹ {(parseFloat(txn.amount) || 0).toFixed(2)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: "center", padding: "20px" }}>
                  No scheduled payments found.
                </td>
              </tr>
            )}
          </tbody>
          {scheduleData.length > 0 && (
            <tfoot className="ledgerFooter" style={{ position: "sticky", bottom: 0, zIndex: 2 }}>
              <tr>
                <td colSpan="2" style={{ padding: "8px 10px", fontWeight: 600 }}>Total</td>
                <td style={{ padding: "8px 10px", textAlign: 'right', fontWeight: 600 }}>₹ {totalAmount.toFixed(2)}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
      {scheduleData.length > visibleCount && (
        <div style={{ textAlign: 'end', padding: "8px 12px", borderTop: "1px solid #E9E9E9", flexShrink: 0 }}>
          <button className="showMoreBtn" onClick={() => setVisibleCount((prev) => prev + 20)}>
            Show More
          </button>
        </div>
      )}
    </div>
  );
};

export default ScheduledFeeShortDetails;
